<template>
  <div class="space-between-y">

    <el-alert title="审核通过" type="success" v-if="vo.examine === 'APPROVED'"
              description="审核通过，家长可以对需求自行进行发布"></el-alert>
    <el-alert show-icon title="审核驳回" type="error" v-if="vo.examine === 'REJECTED'" :description=" vo.examineErrMsg">
    </el-alert>
    <el-alert show-icon title="未审核" type="warning" v-if="vo.examine === 'PENDING'"
              description="未审核期间，家长的需求发布受限"></el-alert>

    <info :infos="[
        {label:'ID',value:vo.id},
        {label:'标题',value:vo.name},
        {label:'描述',value:vo.desc},
        {label:'价格',value:vo.price},
        {label:'教师姓名',value:vo.teacherName},
        {label:'审核状态',value:vo.examine}
    ]"></info>

  </div>
</template>

<script>
import Info from "@/components/system/Info.vue";
import {miuDemand} from "@/api/miu/miuDemand";

export default {
  name: 'DemandDetail',
  components: {
    Info
  },
  props: {
    id: Number
  },

  data() {
    return {
      vo: {},
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      miuDemand.detail(this.id).then(res => {
        this.vo = res.data;
      })
    },
  },


};
</script>

<style scoped>
</style>
